import React from "react";
import { useParams } from "react-router-dom";
import { useQueryGetExamReport } from "@/apis/exam_papers/getExamReport";
import { useQueryGetCategories } from "@/apis/categories/getCategories";
import SATScoreReport from "./components/SATScoreReport";
import ACTScoreReport from "./components/ACTScoreReport";

const ExamReportPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: examReport, isLoading } = useQueryGetExamReport(id || "");
  const { data: categories } = useQueryGetCategories();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!examReport) {
    return <div>No report found</div>;
  }

  const examType = examReport?.exam_set?.exam_type;

  // Render appropriate score report component based on exam type
  if (examType === "ACT") {
    return <ACTScoreReport examReport={examReport} categories={categories || undefined} />;
  } else {
    // Default to SAT for backward compatibility
    return <SATScoreReport examReport={examReport} categories={categories || undefined} />;
  }
};

export default ExamReportPage;
